import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { Translate } from '../../../../shared/LanguageService';
import { CalendarBroker } from '../../types';

type BrokerFilterProps = {
    brokers: CalendarBroker[];
    chosenId: number | null;
    disabled: boolean;
    onChange: (brokerId: number | null) => void;
};

const AllBrokers = '';

function BrokerFilter({ brokers, chosenId, disabled, onChange }: BrokerFilterProps) {
    const isKnown = chosenId !== null && brokers.some((broker) => broker.id === chosenId);

    return (
        <TextField
            id="customer-calendar-broker"
            select
            SelectProps={{ displayEmpty: true }}
            InputLabelProps={{ shrink: true }}
            size="small"
            label={Translate('customer-calendar/brokers')}
            value={isKnown ? String(chosenId) : AllBrokers}
            disabled={disabled}
            onChange={(event) =>
                onChange(event.target.value === AllBrokers ? null : Number(event.target.value))
            }
            sx={{ minWidth: { xs: 0, sm: 220 }, width: { xs: '100%', sm: 'auto' } }}
        >
            <MenuItem value={AllBrokers}>{Translate('customer-calendar/all-brokers')}</MenuItem>
            {brokers.map((broker) => (
                <MenuItem key={broker.id} value={String(broker.id)}>
                    {broker.name}
                </MenuItem>
            ))}
        </TextField>
    );
}

export default BrokerFilter;
